export default __webpack_public_path__ + "assets/images/cb88db2f9c3b5ecfa83cfe88a7585946.png";